import HeroSection from '../components/sections/HeroSection';
import ServicesSection from '../components/sections/ServicesSection';
import TechnologySection from '../components/sections/TechnologySection';
import AboutSection from '../components/sections/AboutSection';

const HomePage = () => {
  return (
    <div className="w-full">
      <HeroSection />
      <ServicesSection />
      <TechnologySection />
      {/* <ReferencesSection /> */}
      <AboutSection />
    </div>
  );
};

export default HomePage;



